import { useEffect, useRef, useState } from 'react';

const stats = [
  { value: 50, suffix: '+', label: 'Brands Served' },
  { value: 8, suffix: '+', label: 'Core Services' },
  { value: 100, suffix: '%', label: 'Results Driven' },
  { value: 24, suffix: '/7', label: 'Always On' },
];

const Counter = ({ value, suffix }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const duration = 1600;
          const start = performance.now();
          const tick = (now) => {
            const p = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setCount(Math.round(eased * value));
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [value]);

  return <span ref={ref} className="stat-value">{count}{suffix}</span>;
};

const Stats = () => (
  <section className="stats-section">
    <div className="container stats-grid">
      {stats.map((s, i) => (
        <div className="stat-card" key={i}>
          <Counter value={s.value} suffix={s.suffix} />
          <span className="stat-label">{s.label}</span>
        </div>
      ))}
    </div>
  </section>
);

export default Stats;
